<template>
    <div class="" v-if="ready">
        <ChoiceModal v-if="modalConfirmar" @confirm="usarBala" @cancel="modalConfirmar = false"></ChoiceModal>
        <EditarFechaPais v-if="!puedeVotar" @completo="forzarVotar = true"></EditarFechaPais>
        <div v-else class="max-w-2xl w-full bg-white rounded-lg shadow-lg overflow-hidden">
            <header class="bg-black p-4 relative">
                <h1 class="text-xl !text-white font-semibold">{{ stories[currentIndex]?.titulo || 'Cargando...' }}</h1>
                <div class="cursor-pointer  absolute right-0 inset-y-0 flex items-center justify-center" @click="() => {
                    modalConfirmar = true;
                }" v-if="puedeBaleada">
                    <div class="flex items-center p-2 bg-white rounded-full mr-3">
                        <img :class="{
                            'opacity-50': balaUsada,
                            'hidden': ocultarBala,

                        }" src="https://www.onlygfx.com/wp-content/uploads/2021/10/bullet-9764.jpg"
                            class="w-6 h-6 rounded-full" />
                    </div>
                </div>
            </header>

            <div class="bg-gray-100 px-4 py-3 overflow-y-auto h-[90px]">
                <p class="text-gray-700 !text-[0.9rem] leading-tight font-semibold">
                    {{
                        stories[currentIndex]?.resumen
                    }}
                </p>
                <div class="bottomStory"></div>
            </div>

            <div class="md:px-10 md:py-6  space-y-4 h-[400px] overflow-y-auto relative" id="story">
                <transition name="fade" mode="out-in">
                    <div v-if="stories.length > 0" :key="stories[currentIndex]?.documentId">
                        <p v-for="(paragraph, index) in paragraphs" :key="index"
                            class="text-gray-800 !text-[1.1rem] leading-6 mb-2">
                            {{ paragraph }}
                        </p>
                    </div>
                    <div v-else class="text-gray-500 text-center">Cargando...</div>
                </transition>
            </div>

            <div class="bg-gray-100 p-4 flex items-center justify-between">
                <button class="p-2 hover:bg-gray-200 rounded-full transition-colors" @click="prevSlide"
                    :disabled="currentIndex === 0">
                    <ChevronLeft class="w-6 h-6 text-gray-600" />
                </button>

                <div v-if="!votacionAbierta">

                </div>
                <StarRating v-else v-model="rating" :max="5" :size="32" @usarBala="usarBala" @voto="doVote"
                    :key="currentIndex" :puedeBaleada="false">
                </StarRating>

                <button class="p-2 hover:bg-gray-200 rounded-full transition-colors" @click="nextSlide"
                    :disabled="currentIndex >= stories.length - 1">
                    <ChevronRight class="w-6 h-6 text-gray-600" />
                </button>
            </div>
        </div>
    </div>
    <Cargando v-else />
</template>

<script setup>
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import ChoiceModal from "../ChoiceModal.vue";
import { miUsuario } from "@/services/usuarios";
import { ref, computed, onMounted, watch, onBeforeMount } from "vue";
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
import StarRating from "@/components/utils/StarRating.vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { notify } from "notiwind";
import EditarFechaPais from "./EditarFicha.vue";
import Cargando from "../escuela/Cargando.vue";
import { onUnmounted } from "vue";

const modalConfirmar = ref(false);
const SERVER = "https://staging-strapi.orsai.org";
const stories = ref([]);
const currentIndex = ref(0);
const rating = ref(0);
const idUsuario = ref(null);
const usuario = ref(null);
const puedeBaleada = ref(false);
const forzarVotar = ref(false);
const ready = ref(false);
const lecturaComputada = ref([]);
const page = ref(1);
const pageSize = ref(20);


const votacionAbierta = computed(() => {
    // Si el dia es Domingo 23 de Febrero en Argentina, cierra la edicion, utilizar momentjs
    const fechaCierre = moment("2025-02-22T23:59:59-03:00")
    const hoy = moment()
    return hoy.isBefore(fechaCierre);
});

const puedeVotar = computed(() => {


    if (!usuario.value) return false;
    if (forzarVotar.value) return true;

    return usuario.value && usuario.value.urlImagen.length && usuario.value.fechaNacimiento &&
        usuario.value.paisNacimiento &&
        usuario.value.pais &&
        usuario.value.extra?.estudios &&
        usuario.value.extra?.profesion &&
        usuario.value.extra?.estadoCivil &&
        usuario.value.extra?.hijos;
});

const paragraphs = computed(() => stories.value[currentIndex.value]?.cuento?.split("\n") || []);

const prevSlide = () => {
    if (currentIndex.value > 0) {
        currentIndex.value--;
    }
    // Hacer scroll al inicio del cuento en story
    const story = document.getElementById("story");
    story.scrollTop = 0;
};

// Función para votar
const doVote = async (voto, baleada = false, notificar = true) => {
    await axios.post(`${SERVER}/api/votos`, {
        data: {
            idCuento: stories.value[currentIndex.value].documentId,
            idUsuario: idUsuario.value,
            voto,
            bala: baleada,
            baleada: true
        },
    });

    // Notificación según el estado del voto
    if (notificar) {
        if (stories.value[currentIndex.value]?.voto) {
            notify(
                {
                    group: "foo",
                    title: "¡Voto actualizado!",
                    type: "warning",
                    text:
                        "Cambiaste tu voto a " + voto + " estrella" + (voto > 1 ? "s" : ""),
                },
                1000
            );
        } else {
            notify(
                {
                    group: "foo",
                    title: "¡Votaste!",
                    type: "success",
                    text:
                        "Votaste esta historia con " +
                        voto +
                        " estrella" +
                        (voto > 1 ? "s" : ""),
                },
                1000
            );
        }
    }

    if (stories.value[currentIndex.value])
        stories.value[currentIndex.value].voto = voto;
};


// La funcion usarBala, vota con cinco estrellas y envia ademas un parametro extra
const usarBala = () => {


    doVote(0, true, false);
    notify(
        {
            group: "foo",
            title: "¡Usaste tu bala!",
            type: "warning",
            text:
                "Votaste esta historia con 5 estrellas y usaste tu bala",
        },
        1000
    );

    puedeBaleada.value = false;
    modalConfirmar.value = false;
};

const nextSlide = () => {
    if (currentIndex.value < stories.value.length - 1) {
        currentIndex.value++;
    }

    // Hacer scroll al inicio del cuento en story
    const story = document.getElementById("story");
    story.scrollTop = 0;

};

const handleScrollEnd = async (event) => {
    console.log("Scrolling");
    const element = event.target;
    if (!element) return;

    // Si no hizo scroll, no hacer nada, con un margen de 100px
    if (element.scrollHeight - element.scrollTop > element.clientHeight + 100) {
        return;
    }


    // class bottomStory en viewport
    const bottomStory = document.querySelector(".bottomStory");
    console.log("Bottom story:", bottomStory);
    const rect = bottomStory.getBoundingClientRect();
    if (rect.top > window.innerHeight) {
        return
    }



    if (lecturaComputada.value.includes(stories.value[currentIndex.value].documentId)) {

        return;
    }
    lecturaComputada.value.push(stories.value[currentIndex.value].documentId);
    await axios.post(`${SERVER}/api/lecturas`, {
        data: {
            idCuento: stories.value[currentIndex.value].documentId,
            idUsuario: idUsuario.value,
            titulo: stories.value[currentIndex.value].titulo,
        },
    });
};

const seedRandom = ref(Math.random());
const fetchStories = async () => {
    try {
        isLoading.value = true;
        const response = await axios.get(`${SERVER}/api/cuentos`, {
            params: {
                "filters[taller]": "dos",
                randomizar: seedRandom.value,
                "pagination[page]": page.value,
                "pagination[pageSize]": pageSize.value,
            }
        });

        page.value++;

        let { data } = await response.data;

        // Si no tiene resumen, quitarla
        data = data.filter((story) => story.resumen);

        // Filtrar al usuario 1, 3 y 1384
        data = data.filter((story) => ![1, 3, 1384].includes(story.idUsuario));

        console.log("Stories:", data);

        stories.value = [...stories.value, ...data];
        isLoading.value = false;
    } catch (error) {
        console.error("Error fetching stories:", error);
    }
};

const isLoading = ref(false);
watch(currentIndex, (newIndex) => {
    if (newIndex >= stories.value.length - 4 && !isLoading.value) {
        fetchStories(true);
    }
});

onBeforeMount(async () => {
    const usr = useAuthStore().usuario;
    usuario.value = usr;
    idUsuario.value = usr.id;



    const id = router.currentRoute.value.query.id;
    if (id) {
        const response = await fetch(`${SERVER}/api/cuentos/${id}`);
        const dataRaw = await response.json();
        const cuento = dataRaw.data;

        // Obtener los votos que le di
        const responseVotosCuento = await fetch(
            `${SERVER}/api/votos?filters[idCuento]=${id}&filters[idUsuario]=${idUsuario.value}`
        );

        const dataVotosRaw = await responseVotosCuento.json();
        const dataVotosCuento = dataVotosRaw.data[0];
        cuento.voto = dataVotosCuento?.voto || 0;
        stories.value = [cuento];
    }


    // Verificar si puede utilizar bullet o no, filtrar en los votos si hay "baleada"
    const responseVotos = await axios.get(
        `${SERVER}/api/votos?filters[idUsuario]=${idUsuario.value}&filters[bala]=true`
    );
    console.log("Votos:", responseVotos.data.data);
    const dataVotos = responseVotos.data.data;
    if (dataVotos.length === 0) {
        puedeBaleada.value = true;
    }

    await fetchStories();
});


const router = useRouter();
onMounted(async () => {


    ready.value = true;

    setTimeout(() => {
        const container = document.querySelector("#story");
        console.log("Container:", container);
        // Agregar evento de scroll al contenedor de párrafos
        if (container) {
            console.log("Adding scroll event");
            container.addEventListener("scroll", handleScrollEnd);
        }
        // Cleanup al desmontar el componente
        onUnmounted(() => {
            if (container) {
                container.removeEventListener("scroll", handleScrollEnd);
            }
        });
    }, 1000);
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Suavizado para la visibilidad de elementos */
.smooth-show {
    transition: opacity 0.5s ease-in-out, transform 0.3s ease;
    opacity: 1;
    transform: translateY(0);
}

.smooth-hide {
    opacity: 0;
    transform: translateY(-10px);
}
</style>
